import { notification } from 'antd'
import axios from 'axios'
import { getAuth, getIdToken } from 'firebase/auth'
import { camelizeKeys, decamelizeKeys } from 'humps'
import { toJson } from 'shared/json'

if (!process.env.REACT_APP_API_NEW_BASE_URL) {
  throw new Error('REACT_APP_API_NEW_BASE_URL is not set. Please check your environment variables.')
}

export const fetcher = axios.create({
  baseURL: `${process.env.REACT_APP_API_NEW_BASE_URL}/bp-internal`,
})

export default function setupNewAxios() {
  fetcher.interceptors.request.use(async (request) => {
    try {
      const firebaseAuth = getAuth()
      const token = await getIdToken(firebaseAuth.currentUser)
      request.headers.authorization = `Bearer ${token}`
    } catch (e) {
      console.error('axios:getIdToken', e)
    }

    if (!(request.data instanceof FormData)) {
      request.data = decamelizeKeys(request.data)
    }
    request.params = decamelizeKeys(request.params)

    return request
  })

  fetcher.interceptors.response.use(
    (res) => {
      if (res.config.responseType === 'blob') {
        return res.data
      }
      return camelizeKeys(res.data)
    },
    (err) => {
      console.error('axios:response.error', { err })
      if (isAccountNotFound(err)) {
        notification.error({ message: '帳號不存在', duration: null })
        return Promise.reject({ ...err.response?.data, accountNotFound: true })
      }
      notification.error({
        message: err.message,
        description: getResponseErrorMessage(err),
        duration: null,
      })
      return Promise.reject(err.response?.data)
    }
  )
}

// 登入後取使用者時，帳號已停用或不存在，後端回 401「<email> not found」
function isAccountNotFound(err) {
  return (
    err.response?.status === 401 &&
    err.config?.url === '/auth/user' &&
    /not found$/.test(err.response?.data?.error?.msg ?? '')
  )
}

function getResponseErrorMessage(err) {
  return (
    toJson(err.response?.data?.error?.detail?.fields) || err.response?.data?.error?.msg || defaultHttpErrorMessage(err)
  )
}

function defaultHttpErrorMessage(err) {
  return err.response ? toJson(err.response.data) : 'Something went wrong.'
}
